module.exports = __webpack_public_path__ + "static/media/mobile-case.c0f9d676.png";